import { useMutation, useQueryClient } from "react-query";
import { useState, useContext } from "react";
import { AuthContext } from "../../Context/AuthContext";

const useUpdateProfile = () => {
  const { token } = useContext(AuthContext);
  const [mutationError, setMutationError] = useState(null);
  const queryClient = useQueryClient();

  const mutation = useMutation(
    async (updatedFields) => {
      const response = await fetch(
        `${process.env.REACT_APP_SERVER_URL}/vesselOwner/profile/update`,
        {
          method: "PATCH",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(updatedFields),
        }
      );

      const responseData = await response.json();

      if (!response.ok) {
        throw new Error(responseData.message);
      }

      return responseData.data;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries("profile");
        setMutationError(null);
      },
      onError: (error) => {
        setMutationError(error.message);
      },
    }
  );

  const updateProfile = async (updatedFields) => {
    try {
      const updatedData = await mutation.mutateAsync(updatedFields);
      return updatedData;
    } catch (error) {
      throw error;
    }
  };

  return {
    mutation,
    mutationError,
    updateProfile,
  };
};

export default useUpdateProfile;

